import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="A" transform="translate(27.000000, 17.000000)">
        <path
          d="M 0 54.56 L 18.72 0 L 27.04 0 L 45.76 54.56 L 38.8 54.56 L 34 40 L 11.84 40 L 6.96 54.56 L 0 54.56 Z M 13.92 33.6 L 31.84 33.6 L 23.04 6.4 L 22.8 6.4 L 13.92 33.6 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
